// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SwiperA_TheComp__BZt_x"};